import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const defecationListSelector = createSelector(
  (state: RootState) => state.defecation.defecationList,
  (defecationList) => defecationList,
);

export const isEnableLoadingSelector = createSelector(
  (state: RootState) => state.defecation,
  (item) => item.nextToken !== '',
);

export const isInitSelector = createSelector(
  (state: RootState) => state.defecation,
  (item) => item.nextToken !== null,
);

export const isInitDefecationSelector = createSelector(
  (state: RootState) => state.defecation,
  (item) => item.nextToken !== null,
);
